<template>
  <section class="app-main" style="clear: both;min-height: 100vh;overflow: hidden;">
    <transition name="fade" mode="out-in" style="height:100%;">
      <router-view style="height:100%"></router-view>
    </transition>
  </section>
</template>

<script>
export default {

}
</script>

<style>
.app-main {
  /* padding: 15px; */
  box-sizing: border-box;
}
</style>
